import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

/**
 * Takes in a vimeoId, and returns an observable with an HTML playable video url
 */
@Injectable({
  providedIn: "root"
})
export class VimeoPlayableService {
  vimeoUrlMap = new Map<string, string>();

  constructor(private http: HttpClient) { }

  fetch(videoId: string): Observable<string> {
    if (this.vimeoUrlMap.has(videoId)) {
      return of(this.vimeoUrlMap.get(videoId)!);
    }

    return this.http.get(`${environment.API_ENDPOINT}/vimeo/video/${videoId}`).pipe(
      map(video => video['files'].find(file => file.quality === 'hd').link),
      tap((url) => this.vimeoUrlMap.set(videoId, url))
    );
  }

}
